import i18next from 'i18next';

i18next.addResources('es', 'analytics', {
  byCountry: 'Por país',
  byTerritory: 'Por territorio',
  byTheme: 'Por tema',
  byTerm: 'Por plazo',
  byScope: 'Por ámbito',
  byType: 'Por tipo de obra',
  count: 'Cantidad',
  investment: 'Inversión',
  measure: 'Medir por',
  noTerm: 'Sin plazo',
  noScope: 'Sin ámbito',
  noType: 'Sin tipo',
  investmentNote: 'Inversión estimada en millones de USD. Una acción con varios valores cuenta en cada uno.',
  lead: 'Los gráficos muestran los {{total}} proyectos y acciones que coinciden con los filtros. Al hacer clic en una barra o porción se filtra por ese valor.',
  unitCount: 'Proyectos y acciones',
  unitInvestment: 'USD millones'
});

i18next.addResources('en', 'analytics', {
  byCountry: 'By country',
  byTerritory: 'By territory',
  byTheme: 'By theme',
  byTerm: 'By term',
  byScope: 'By scope',
  byType: 'By type of work',
  count: 'Count',
  investment: 'Investment',
  measure: 'Measure by',
  noTerm: 'No term',
  noScope: 'No scope',
  noType: 'No type',
  investmentNote: 'Estimated investment in USD millions. An action with several values counts in each of them.',
  lead: 'The charts show the {{total}} projects and actions that match the filters. Clicking a bar or slice filters by that value.',
  unitCount: 'Projects and actions',
  unitInvestment: 'USD millions'
});

i18next.addResources('pt', 'analytics', {
  byCountry: 'Por país',
  byTerritory: 'Por território',
  byTheme: 'Por tema',
  byTerm: 'Por prazo',
  byScope: 'Por âmbito',
  byType: 'Por tipo de obra',
  count: 'Quantidade',
  investment: 'Investimento',
  measure: 'Medir por',
  noTerm: 'Sem prazo',
  noScope: 'Sem âmbito',
  noType: 'Sem tipo',
  investmentNote: 'Investimento estimado em milhões de USD. Uma ação com vários valores conta em cada um deles.',
  lead: 'Os gráficos mostram os {{total}} projetos e ações que coincidem com os filtros. Ao clicar em uma barra ou fatia, filtra-se por esse valor.',
  unitCount: 'Projetos e ações',
  unitInvestment: 'USD milhões'
});
